import { Row, Col } from "reactstrap";
import DownloadCard from "./DownloadCard";

import { useTranslation } from "react-i18next";

import "../styles/DownloadCardGrid.css";

const DownloadCardGrid = (props) => {
  const { t } = useTranslation();

  return (
    <Row className="download-card-grid">
      {props.downloadCardData.map((card, index) => (
        <Col key={index} xs="12" sm="6" md="4" lg="3">
          <DownloadCard
            title={t(card.title)}
             text={card.text ? t(card.text) : undefined}
             image={card.image}
            downloadTitle={t(card.downloadTitle)}
            downloadLinks={card.downloadLinks.map((link) => ({
              name: t(link.name),
              url: link.url,
            }))}
          />
        </Col>
      ))}
    </Row>
  );
};
export default DownloadCardGrid;
